import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=24ce09d8&scoped=true&"
import script from "./Trip.vue?vue&type=script&lang=js&"
export * from "./Trip.vue?vue&type=script&lang=js&"
import style0 from "./Trip.vue?vue&type=style&index=0&id=24ce09d8&prod&lang=css&"
import style1 from "./Trip.vue?vue&type=style&index=1&id=24ce09d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ce09d8",
  null
  
)

export default component.exports